import IState from '../models/IState';
import { createSelector } from "reselect";
import { addSensorInitialState, filterInitialState } from '../state/sensor.state';
import { IOption } from '../../models/IReduxFormHandlers';
import modelEnum from '../../constants/model.enum';
import { formatUtcToLocal } from '../../constants/common.constant';

const stateAllUsers = (state: IState) => state.user.userList.users;
const stateAllSensors = (state: IState) => state.sensor.sensorList.sensors;
const getSensor = (state: IState) => state.sensor.sensor.sensor;
const getBuildings = (state: IState) => state.sensor.buildingList.buildings;
const stateAllDevices= (state:IState)=>state.sensor.allDevices;
const stateUserType = (state: IState) => state.auth.userType;
const stateUserName = (state: IState) => state.auth.userName;

export const allSensors = createSelector(
    stateAllSensors,
    stateUserType, 
    (sensors, userType) => {
        if( sensors !== undefined)
        {
            if (sensors.SensorLocations && sensors.SensorLocations.length > 0) {
                return sensors.SensorLocations.map((sensor: any) => {
                    let isEdit = userType.toString() === 'General' ? (sensor.IsPrimary ?? false) : true;
                    let isDelete = userType.toString() === 'General' ? (sensor.IsPrimary ?? false) : true;
                    return {
                        id: sensor.ID,
                        Building: sensor.Building,
                        Comments: sensor.Comments,
                        CustomerId: sensor.CustomerID,
                        Floor: sensor.Floor,
                        ICCID: sensor.ICCID,
                        Location: sensor.Location,
                        Room: sensor.Room,
                        User: sensor.User,
                        isDelete: isDelete,
                        isEdit: isEdit,
                        Model: sensor.Model,
                        LatestPayloadTime: sensor.LatestPayloadTime ? (sensor.Model === modelEnum.IAQ.toLowerCase() ? 
                            (formatUtcToLocal(sensor.LatestPayloadTime)) : sensor.LatestPayloadTime) : null,
                        IsPrimary: sensor.IsPrimary ?? false,
                    }
                })
            }
        }
        return [];
    }
)

export const getFilterSensorSelector = createSelector(
    getSensor,
    (sensor) => {
        let finalSensor = JSON.parse(JSON.stringify(filterInitialState));
        if (sensor !== null) {
            finalSensor.Building = sensor.Building;
            finalSensor.Comments = sensor.Comments;
            finalSensor.CustomerId = sensor.CustomerId;
            finalSensor.Floor = sensor.Floor;
            finalSensor.ICCID = sensor.ICCID;
            finalSensor.Location = sensor.Location;
            finalSensor.Room = sensor.Room;
            finalSensor.User = sensor.User;
            finalSensor.UserId = sensor.UserId;
            finalSensor.SensorType = 0; //Fixed typefor sensor iaq that is 0
            finalSensor.LatestPayloadStartDateTime = sensor.LatestPayloadStartDateTime;
            finalSensor.LatestPayloadEndDateTime = sensor.LatestPayloadEndDateTime;
        }
        return finalSensor;
    }
)

export const getSensorSelector = createSelector(
    getSensor,
    (sensor) => {
        let finalSensor = JSON.parse(JSON.stringify(addSensorInitialState));
        if (sensor != null) {
            finalSensor.Building = sensor.Building;
            finalSensor.Comments = sensor.Comments;
            finalSensor.CustomerId = sensor.CustomerID;
            finalSensor.Floor = sensor.Floor;
            finalSensor.ICCID = sensor.ICCID;
            finalSensor.Location = sensor.Location;
            finalSensor.Room = sensor.Room;
            finalSensor.User = sensor.User;
            finalSensor.UserId = sensor.UserID;
            finalSensor.SendMail = sensor.SendMail;
            finalSensor.SensorType = 0
            // finalSensor.SensorType = (sensor.Model === modelEnum.IAQ.toLowerCase() || sensor.Model === modelEnum.IAQ) ? "0" : "1"
        }
        return finalSensor;
    }
)
export const allUserSensorSelector = createSelector(
    stateAllUsers,
    stateUserType,
    stateUserName,
    (allUsers, userType, userName) => {
        let userOptions: IOption[] = [{ id: -1, value: '--select--' }];

        if (allUsers?.Users?.length) {
            userOptions.push(
                ...allUsers.Users.map((user: any) => ({
                    id: user.Id,
                    value: user.UserName
                }))
            );
        }
        if (userType.toString() === 'General') {
            userOptions = userOptions.filter(
                (option: IOption) => option.id === -1 || option.value === userName
            );
        }

        return userOptions;
    }
);

export const allBuildingsSelector = createSelector(
    getBuildings,
    (allBulding) => {
        if (allBulding != null) {
            //allBulding = [{name: "A"},{name: "B"},{name: "C"}]
            return allBulding;
        }
    }
)

export const allSensorsWithoutPagination = createSelector(
    stateAllDevices,
    (devices) => {
        if(devices!==null) return devices
    }
)